export const FEED_ITEM_PILL_BORDER_COLORS = {
  default: 'd-recipe-feed-item-pill__border--default',
  ai: 'd-recipe-feed-item-pill__border--ai',
  critical: 'd-recipe-feed-item-pill__border--critical',
};

export default {
  FEED_ITEM_PILL_BORDER_COLORS,
};
